export default "__VITE_ASSET__BKiYUGI4__"